import { TpaEventsListenerManagerSymbol } from '../symbols'
import { withDependencies } from '@wix/thunderbolt-ioc'
import type { TpaHandlerProvider } from '@wix/thunderbolt-symbols'
import type { ITPAEventsListenerManager } from '../types'
import type { ISessionManager } from 'feature-session-manager'
import { SessionManagerSymbol } from 'feature-session-manager'

export type HandlerResponse = {
	instance: string
}

export const RevalidateSessionHandler = withDependencies(
	[SessionManagerSymbol, TpaEventsListenerManagerSymbol],
	(sessionManager: ISessionManager, tpaEventsListenerManager: ITPAEventsListenerManager): TpaHandlerProvider => ({
		getTpaHandlers() {
			return {
				async revalidateSession(compId, msgData, { appDefinitionId }): Promise<HandlerResponse> {
					await sessionManager.loadNewSession()
					const payload = {
						instance: sessionManager.getAppInstanceByAppDefId(appDefinitionId)!,
					}
					tpaEventsListenerManager.dispatch('INSTANCE_CHANGED', () => payload, { appDefinitionId })
					return payload
				},
			}
		},
	})
)
